<template>
  <b-container>
    <b-card
      title="Shit happens"
      class="col-lg-8 offset-lg-2 col-xl-4 offset-xl-4"
    >
      <template v-if="done">
        <p class="card-text">
          전송이 완료되었습니다. 메일을 확인해주세요.
        </p>
        <p class="card-text">
          We've emailed you instructions. Check your email inbox.
        </p>
      </template>
      <template v-else>
        <p class="card-text">
          등록하신 이메일주소로 비밀번호 변경 안내 메일이 곧 발송됩니다 :)
        </p>
        <p class="card-text">
          If your email exists in our database, you will receive a password
          recovery link at your email address in a few minutes.
        </p>
        <form @submit.prevent="send">
          <b-form-group label="Email" label-class="font-weight-bold">
            <b-form-input
              type="email"
              v-model="user.email"
              :state="feedback.email ? !feedback.email : null"
              required
            ></b-form-input>
            <b-form-invalid-feedback
              :key="index"
              v-for="(f, index) in feedback.email"
              v-if="feedback.email"
            >
              {{ f }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button type="submit" variant="primary"
            >Send me instructions!</b-button
          >
        </form>
      </template>
    </b-card>
  </b-container>
</template>

<script>
import Vue from "vue";
import { User } from "../models";

export default Vue.component("passwordReset", {
  data() {
    return {
      user: new User(window.user),
      feedback: {},
      done: false
    };
  },
  methods: {
    async send() {
      try {
        await this.user.resetPassword({
          email: this.user.email
        });
        this.done = true;
      } catch ({ response }) {
        if (response.status === 400) {
          this.feedback = response.data;
        }
      }
    }
  }
});
</script>
